export const PricingDetails = [
  {
    title: "Subscription",
    details: [
      "Everything included in Plus",
      "Higher message limits on GPT-4, GPT-4o, and tools like DALL·E, Browsing, data analysis, and more",
      "Create and share GPTs with your workspace",
      "Admin console for workspace management",
    ],
    price: 9,
  },
  {
    title: "Perpetual",
    details: [
      "Everything included in Team",
      "Unlimited, high speed access to GPT-4,  GPT-4o, and tools like DALL·E, Browsing, data analysis, and more",
      "Expanded context window for longer inputs",
      "Enterprise data excluded from training by default & custom data retention windows",
      "Admin controls, domain verification, and analytics",
      "Priority support & ongoing account management",
    ],
    price: 29,
  },
];

export const DRAFT_TYPES = {
  TEXT: 1,
  JSON: 2,
};

export const DRAFT_TYPE_OPTIONS = [
  {
    id: DRAFT_TYPES.TEXT,
    description: "TEXT",
    file: "txt",
  },
  {
    id: DRAFT_TYPES.JSON,
    description: "JSON",
    file: "json",
  },
];

export const RESPONSE_STATUS = {
  SUCCESS: 200,
  INTERNAL_SERVER_ERROR: 500,
  FORBIDDEN: 403,
  CONFLICT: 409,
};

export const PAGE_ROUTES = {
  HOME: "/",
  LOGIN: "/signin",
  SIGNUP: "/signup",
};

export const MAX_NUMBER_OF_NEW_DRAFTS = 20;
